import gql from 'graphql-tag'

export const UPDATE_SCHEDULE_DATE = gql`
  mutation updateScheduleDate($date: String) {
    updateScheduleDate(date: $date) @client
  }
`

export const GET_SCHEDULE_DATE = gql`
  query {
    scheduleDate @client {
      date
    }
  }
`

export const SHOULD_UPDATE_SCHEDULE = gql`
  query {
    shouldUpdateSchedule @client
  }
`

export const SET_SHOULD_UPDATE_SCHEDULE = gql`
  mutation setUpdateSchedule {
    setUpdateSchedule @client
  }
`
